module.exports = __webpack_public_path__ + "img/paint-02.2c099e4b.png";